module.exports = __webpack_public_path__ + "static/media/GitHubLogo.cefc2023.png";